/* eslint-disable spaced-comment */
import React, { useRef, useState } from 'react'
import MessagesSvg from '../other/svg/MessagesSvg'
import View from './View'
import Text from './Text'
import DraggableWrapper from './DraggableWrapper'
import CloseXSvg from '../other/svg/CloseXSvg'
import { useSelector, useDispatch } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { UPDATE_SEEN_BY_DEALER } from 'dealer-reducers'
interface Props {
  children: React.ReactNode
  offerHashId: string
}

const ConversationButton = ({ children, offerHashId }: Props): JSX.Element => {
  const notificationsCount = useSelector((state: RootReducer) => state.conversationReducer.unread_messages)
  const showNotificationsCount = notificationsCount > 0
  const validatedNotificationsCount = notificationsCount > 9 ? '9+' : notificationsCount
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const chatRef = useRef<HTMLDivElement>(null)
  return (
    <DraggableWrapper
      elementWidth={75}
      elementHeight={75}
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        //@ts-ignore
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!chatRef.current?.contains(event.target as Node)) {
          setIsOpen(!isOpen)
          dispatch(UPDATE_SEEN_BY_DEALER({ offer_hash_id: offerHashId }))
        }
      }}>
      <div className="bg-groupBlue p-5 rounded-[25px] relative">
        {isOpen ? (
          <View className="flex items-center justify-center">
            <CloseXSvg style={{ width: '32px', height: '32px' }} className="text-white" />
          </View>
        ) : (
          <>
            <MessagesSvg className="w-8 h-8 text-white" />
            {showNotificationsCount && (
              <View className="absolute top-0 right-0 bg-errorRed rounded-[25px] w-6 h-6 flex justify-center items-center !border-white border">
                <Text className="!text-l !font-Medium !text-white">{validatedNotificationsCount}</Text>
              </View>
            )}
          </>
        )}
      </div>
      <div
        ref={chatRef}
        style={{
          transform: isOpen ? 'scale(1)' : 'scale(0)',
          transformOrigin: 'bottom center'
        }}
        className={`absolute bottom-[120%] right-[-20px] justify-center items-center flex z-10 transition-all duration-300 ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}>
        <div className="w-[450px] h-[500px] p-4 flex flex-col">
          <div className="w-full flex-1 h-full shadow-xl shadow-darkBlue shadow-bothSmall rounded-[25px]">
            {children}
          </div>
        </div>
      </div>
    </DraggableWrapper>
  )
}

export default ConversationButton
